// src/services/comandoService.js

export async function enviarComando(ip, mensaje) {
  try {
    const url = `http://${ip}/comando`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: mensaje,
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    const data = await response.text();
    return data;
  } catch (error) {
    console.error("❌ Error al enviar comando:", error);
    throw error;
  }
}
